import { isSameDay } from '@sharedlib/common/utils/date';
import { type MonthViewDay, type WeekDay } from 'calendar-utils';

export class AngularCalendarHelper {
  public static findDayIndex(date: Date, days: (MonthViewDay | WeekDay)[]): number | undefined {
    for (let i = 0; i < days.length; i++) {
      const day = days[i];
      if (isSameDay(day.date, date)) {
        return i;
      }
      if (day.date > date) {
        return;
      }
    }
  }

  public static scrollToDateHandler(date: Date, days: MonthViewDay[], element: HTMLElement): boolean {
    if (date) {
      const dayIndex: number | undefined = AngularCalendarHelper.findDayIndex(date, days);
      if (dayIndex === undefined) {
        return false;
      }

      const dayCell = element.querySelectorAll('.cal-days .cal-day-cell').item(dayIndex);

      dayCell?.scrollIntoView({ behavior: 'smooth' });
      return true;
    }

    return false;
  }
}
